import ApiLokalni from "../../ApiLokalni.ts";
import axios from "axios";

interface BlogArticle {
    id: string;
    link: string;
    title: string;
    excerpt:string;
    content:string;
    mainImgUrl:string;
}

interface Article {
    article: BlogArticle;
}

interface BlogCategories {
    link: string;
    name: string;
}

interface Categories {
    categories: BlogCategories[];
}

class BlogArticleApi extends ApiLokalni {

    public constructor(token : string) {
        super(token);
    }

    public async article() : Promise<Article> {

        const url = this.getUrl() + '/api/v1/blog/article';

        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
        }

        return {
            article: {
                id: '', link: '', title: '', content: '', excerpt: '', mainImgUrl: ''
            }
        };
    }

    public async categories() : Promise<Categories> {

        const url = this.getUrl() + '/api/v1/blog/categories';

        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
        }

        return {
            categories: []
        };
    }

}

export default BlogArticleApi;